'use strict';

var _Maker = require('./Maker');

var _Maker2 = _interopRequireDefault(_Maker);

var _Currency = require('./eth/Currency');

var _conversion = require('./utils/conversion');

var _QueryApi = require('./QueryApi');

var _QueryApi2 = _interopRequireDefault(_QueryApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

for (var symbol in _Currency.currencies) {
  _Maker2.default[symbol] = _Currency.currencies[symbol];
}

_Maker2.default.currencies = _Currency.currencies;
_Maker2.default.QueryApi = _QueryApi2.default;
_Maker2.default.utils = { stringToBytes32: _conversion.stringToBytes32 };

module.exports = _Maker2.default;